import React, { useEffect, useState } from 'react'

import 'react-multi-carousel/lib/styles.css'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate, useParams } from 'react-router-dom'

import { TSEntryForm } from './TSEntryForm'
import AppLayout from '../common/AppLayout'
import AppTitle from '../common/AppTitle'
import { useContentWrapper } from '../common/ContentWrapperProvider'

function TimesheetEditPage() {
    const {t} = useTranslation()
    const params = useParams()
    const navigate = useNavigate()
    const [clientName, setClientName] = useState('')

    useEffect(() => {
        if (isNaN(parseInt(params.entryId as string)) || parseInt(params.entryId as string) <= 0) {
            navigate('/app/timesheet')
        }
    }, [params.entryId])

    return (
        <AppLayout>
            <AppTitle append={<Link to={'/app/timesheet'}>
                <button className="btn amani-primary">{t('back')}</button>
            </Link>}>{clientName ? t('edit_record_for_client', {client: clientName}) : t('edit_record')}</AppTitle>

            <div className="rounded-content-body p-3">
                <TSEntryForm id={parseInt(params.entryId as string)}
                             onLoad={(entry) => setClientName(
                                 [entry.clientFirstName, entry.clientLastName].filter(Boolean).join(' '))}/>
            </div>
        </AppLayout>
)
}

export default TimesheetEditPage
